

export enum StreamingStateEnum {
    WebRtcDisconnected = 'WebRtcDisconnected',
    WebRtcConnetting = 'WebRtcConnetting',
    WebRtcConnected = 'WebRtcConnected',
    StreamDisconnected = 'StreamDisconnected',
    StreamConnetting = 'StreamConnetting',
    StreamConnected = 'StreamConnected'
}
